const theme = {
    fontSource: 'https://fonts.googleapis.com/css?family=Poppins',
    fontFamily: 'Poppins, sans-serif',
    color: '#121212'
  };
  
  export default theme;